import { Tbody } from "@chakra-ui/react";
import { useQueryParams } from "@madkom/query-params";

import { SkeletonTableBody } from "components/Table/SkeletonTableBody";

import { useGetPaginatedUserAppointments } from "../../../../infrastructure/useGetPaginatedUserAppointments";

import { AppointmentRow } from "./AppointmentRow";

interface IProps {
  limit: number;
}

const TableBody = ({ limit }: IProps) => {
  const { params } = useQueryParams<{ offset: number }>();
  const { data: appointments, isFetched } = useGetPaginatedUserAppointments(
    {
      limit: limit,
      offset: params.offset,
    },
    {
      suspense: false,
    }
  );

  if (!appointments || !isFetched) {
    return <SkeletonTableBody rowsNum={limit} colNum={6} />;
  }

  return (
    <Tbody maxW="1000px">
      {appointments.userAppointments.map((appointment) => {
        return <AppointmentRow appointment={appointment} />;
      })}
    </Tbody>
  );
};

export { TableBody };
